export default {"src":"/_next/static/media/cominho-plus.391c5fd8.svg","height":30,"width":30,"blurWidth":0,"blurHeight":0};